import React from "react"
import { Row } from "antd"
import { inject, observer } from "mobx-react"
import { setCurrentApp } from "app/api/localTools"
import { withRouter } from 'react-router-dom'
import cx from "classnames"

@inject("auth")@observer
class SwitchApp extends React.Component {
  switchApp = (app) => {
    setCurrentApp(app)
    this.props.history.push(`/public/main/${app}/dashboard`)
    this.forceUpdate()
  }

  render() {
    const { auth: { apps }, className } = this.props
    const currentApp = window.location.pathname.split("/")[3]
    console.log('cur: ', currentApp)
    return (
      <Row type="flex" align="middle" justify="center" className={className}>
        {
          apps.map(app =>
            <div
              key={app}
              className={cx({
                "active": currentApp === app,
                "cursor-p": true
              })}
              onClick={() => this.switchApp(app)}
            >
              {app}
            </div>
          )
        }
      </Row>
    )
  }
}

export default withRouter(SwitchApp)



// WEBPACK FOOTER //
// ./src/app/components/common/SwitchApp/SwitchApp.js